import LoadingOutlined from "@ant-design/icons/es/icons/LoadingOutlined";
import classNames from 'classnames';
import CSSMotion from 'rc-motion';
import React, { forwardRef } from 'react';
import IconWrapper from './IconWrapper';
var InnerLoadingIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var prefixCls = _ref.prefixCls,
      className = _ref.className,
      style = _ref.style,
      iconClassName = _ref.iconClassName;
  var mergedIconCls = classNames("".concat(prefixCls, "-loading-icon"), className);
  return /*#__PURE__*/React.createElement(IconWrapper, {
    prefixCls: prefixCls,
    className: mergedIconCls,
    style: style,
    ref: ref
  }, /*#__PURE__*/React.createElement(LoadingOutlined, {
    className: iconClassName
  }));
});

var getCollapsedWidth = function getCollapsedWidth() {
  return {
    width: 0,
    opacity: 0,
    transform: 'scale(0)'
  };
};

var getRealWidth = function getRealWidth(node) {
  return {
    width: node.scrollWidth,
    opacity: 1,
    transform: 'scale(1)'
  };
};

var LoadingIcon = function LoadingIcon(props) {
  var prefixCls = props.prefixCls,
      loading = props.loading,
      existIcon = props.existIcon,
      className = props.className,
      style = props.style;
  var visible = !!loading;

  if (existIcon) {
    return /*#__PURE__*/React.createElement(InnerLoadingIcon, {
      prefixCls: prefixCls,
      className: className,
      style: style
    });
  }

  return /*#__PURE__*/React.createElement(CSSMotion, {
    visible: visible,
    // We do not really use this motionName
    motionName: "".concat(prefixCls, "-loading-icon-motion"),
    removeOnLeave: true,
    onAppearStart: getCollapsedWidth,
    onAppearActive: getRealWidth,
    onEnterStart: getCollapsedWidth,
    onEnterActive: getRealWidth,
    onLeaveStart: getRealWidth,
    onLeaveActive: getCollapsedWidth
  }, function (_ref2, ref) {
    var motionCls = _ref2.className,
        motionStyle = _ref2.style;
    return /*#__PURE__*/React.createElement(InnerLoadingIcon, {
      prefixCls: prefixCls,
      className: className,
      style: Object.assign(Object.assign({}, style), motionStyle),
      ref: ref,
      iconClassName: motionCls
    });
  });
};

export default LoadingIcon;